// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___3Fmu","importantInfo":"styles_importantInfo__RqGf7"};